<template>
  <div id="app">
    <router-view></router-view>
    <Language v-show="false" />
  </div>
</template>

<script>
import { userInfo } from '@/api/user/user'
import Language from '@/components/experimentation/language'
export default {
  name: 'app',
  created() {
    if (process.env.NODE_ENV !== 'development') this.changeBackGroundImg()
    window.localStorage.setItem('expId', 1)
    let token = window.localStorage.getItem('token')
    if (token) {
      this.getUserInfo()
      this.$store.dispatch('personal/setQuestionShowAsync')
    }
  },
  components: { Language },
  computed: {},
  methods: {
    getUserInfo() {
      var that = this
      userInfo().then((res) => {
        const { userInfo, school, questionShow } = res.data
        that.$store.commit('SET_USETINFO', userInfo)
        that.$store.commit('SETUSERLOGIN', true)
      })
    },
    changeBackGroundImg() {
      document.body.style.setProperty(
        '--people-bg',
        "url('/images/exp_people.png')"
      )
      document.body.style.setProperty(
        '--num-bg',
        "url('/images/exp_num.png')"
      )
      document.body.style.setProperty(
        '--objbtn-bg',
        "url('/images/btn_bg.png')"
      )
      document.body.style.setProperty(
        '--performance-bg',
        "url('/images/score.png')"
      )
      document.body.style.setProperty(
        '--tip-bg',
        "url('/images/answer_tip_box_y.png')"
      )
      document.body.style.setProperty(
        '--tipn-bg',
        "url('/images/answer_tip_box_n.png')"
      )
      document.body.style.setProperty(
        '--start-bg',
        "url('/images/btn.png')"
      )
      document.body.style.setProperty(
        '--videobtn-bg',
        "url('/images/btn_default.png')"
      )
      document.body.style.setProperty(
        '--videobtna-bg',
        "url('/images/btn_active.png')"
      )
      document.body.style.setProperty(
        '--exp1_default-bg',
        "url('/images/exp1_default.png')"
      )
      document.body.style.setProperty(
        '--exp1_active-bg',
        "url('/images/exp1_active.png')"
      )
      document.body.style.setProperty(
        '--report_title-bg',
        "url('/images/report_title.png')"
      )
      document.body.style.setProperty(
        '--exp_item_active',
        "url('/images/theme/purple-red/exp_item_active.png')"
      )
      document.body.style.setProperty(
        '--exp_item_default',
        "url('/images/theme/purple-red/exp_item_default.png')"
      )
      document.body.style.setProperty(
        '--exp_bg',
        "url('/images/theme/purple-red/exp_bg.png')"
      )
      document.body.style.setProperty(
        '--exp_header_score',
        "url('/images/theme/purple-red/exp_header_score.png')"
      )
      document.body.style.setProperty(
        '--logo-bg',
        "url('/images/logobg.png')"
      )
      document.body.style.setProperty(
        '--homebtn-bg',
        "url('/images/3@2x.png')"
      )
    },
  },
}
</script>
<style lang="scss" scoped>
html,
body,
#app {
  height: 100%;
}
</style>

